import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UserGroupsComponent } from './user-groups/user-groups.component';
import { UserProfileComponent } from './user-profile/user-profile.component';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [UserGroupsComponent, UserProfileComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent {}
